module.exports = __webpack_public_path__ + "img/logo-w.17b7a25e.svg";